import React from 'react';
import { formFieldTypes, formStringFieldPatterns, settingsValueFieldTypes, hiddenLabelFieldTypes, noValueFieldTypes } from '../../constants.js';
import i18next from "../../i18n.js";
import * as CheckFunctions from '../helpers/CheckFunctions.js';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { downloadTemplate } from '../helpers/HelperFunctions.js';
import { viewOrder } from '../documents/DocumentHelpers.js';
export function InputContainer(props) {
    const check = props.check ? checkField(props) : false;
    let { name, label, labelText, helpText } = props;
    let labelElement = props.hideLabel || hiddenLabelFieldTypes.includes(props.type) || !label ? <></> : <div className={'label-contaner' + (props.viewOrderBtnText ? ' has-view-btn' : '')}>
        <label htmlFor={name} className={props.required ? "required" : ""}>{label}</label>
        {labelText && <div className='label-text'>{labelText}</div>}
        {props.type === formFieldTypes.attachments && props.showTemplateLoadBtn && <Button onClick={() => downloadTemplate(props.templateFileName)} >{i18next.t('other.loadTemplate')}</Button>}
        {props.viewOrderBtnText && <Button onClick={() => viewOrder(props.businessTripNodeRef)} >{props.viewOrderBtnText}</Button>}

        {/* поле з посиланнями показує helpText усередині себе, підказка йому не потрібна */}
        {helpText && !(props.type === formFieldTypes.attachments && (props.allowLinks || props.allowPhoto)) && <OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip id={`${name}-tooltip`}>
                {helpText}
            </Tooltip>}
        >
            <div className='help-btn' />
        </OverlayTrigger>}
    </div>
    return (props.type === formFieldTypes.empty ? "" : <>
        {labelElement}
        {props.children}
        {check ? < div className="help-block">{check}</div> : ""}
    </>);
}
export function checkField(field) {
    let requiredMessage = i18next.t("requiredField");
    let wrongFormatMessage = i18next.t("badFieldFormat");
    let wrongIbanMessage = i18next.t("wrongIbanMessage");
    if (field) {
        if (field.errorText) return field.errorText;
        const fieldValue = field.value;
        // поле без значення, тому перевіряти в ньому нічого
        if (noValueFieldTypes.includes(field.type)) return false;
        if (field.type === formFieldTypes.startingPoint) return checkStartingPoint(field);
        if (field.type === formFieldTypes.dateIntervalInput) return checkDateInterval(field);
        if (field.type === formFieldTypes.route) return checkRoute(field);
        if (field.type === formFieldTypes.attachments) return true;
        if (field.type === formFieldTypes.doublecheckbox) {
            if (field.required && (fieldValue === undefined || fieldValue === null)) return requiredMessage;
            return false;
        }
        if (field.required && !fieldValue) return requiredMessage;
        if (field.pattern && fieldValue) {
            switch (field.pattern) {
                case formStringFieldPatterns.codeEDRPO:
                    return !CheckFunctions.checkCompanyRegisterCode(fieldValue) ? wrongFormatMessage : "";
                case formStringFieldPatterns.codeIPN:
                    return !CheckFunctions.checkIPN(fieldValue) ? wrongFormatMessage : "";
                case formStringFieldPatterns.email:
                    return !CheckFunctions.checkEmail(fieldValue) ? wrongFormatMessage : "";
                case formStringFieldPatterns.mFO:
                    return !CheckFunctions.checkMFO(fieldValue) ? wrongFormatMessage : "";
                case formStringFieldPatterns.iBan:
                    return !CheckFunctions.checkBankScore(fieldValue) ? wrongIbanMessage : "";
                case formStringFieldPatterns.bankCard:
                    return !CheckFunctions.checkBankCard(fieldValue) ? wrongIbanMessage : "";
            }
        }
    }
}
function checkStartingPoint(field) {
    if (field.settings.mainCityField) {
        if (!field.value || !field.value[field.settings.mainCityField]) return i18next.t("requiredField");
    }
    if (field.settings.mainPlaceField && field.settings.commentField) {
        if (!field.value[field.settings.mainPlaceField] && !field.value[field.settings.commentField]) {
            return i18next.t("notMainPlaceError");
        }
    }
}
function checkDateInterval(field) {
    const errorMessage = i18next.t("requiredField");
    if (!field.value) {
        return errorMessage;
    }
    if (field.settings.startField && !field.settings.hideStartDate && !field.value[field.settings.startField]) {
        return errorMessage;
    }
    if (field.settings.endField && !field.settings.hideEndDate && !field.value[field.settings.endField]) {
        return errorMessage;
    }
}
function checkRoute(field) {
    const errorMessage = i18next.t("requiredField");
    if (!field.value) {
        return errorMessage;
    }
    if (field.settings.fromField && !field.value[field.settings.fromField]) {
        return errorMessage;
    }
    if (field.settings.toField && !field.value[field.settings.toField]) {
        return errorMessage;
    }
}